import Api from "./Api";
import ApiError from "./ApiError";
import ObjectHelper from "../components/helpers/ObjectHelper";

export default class ApiHandler {
  _auth = false;

  /**
   * Get instance of this class
   * @returns {ApiHandler}
   */
  static get i() {
    return new ApiHandler();
  }

  auth() {
    this._auth = true;
    return this;
  }

  async get(endpoint) {
    const api = new Api();
    if (this._auth) api.auth();

    try {
      const response = await api.get(endpoint);
      const {status, message, data} = response.data;

      if (!status) {
        return ApiError({
          title: message,
          message: data,
        });
      }

      return data;
    } catch (error) {
      return ApiError(error);
    }
  }

  async _sendForm(method, endpoint, data, options) {
    options = Object.assign({
      formName: '',
      formik: null,
    }, options);

    const {formName, formik} = options;
    const requestData = ('' === formName) ? data : {[formName]: data};

    const events = {
      beforeSetErrors: ObjectHelper.methodExists(options, 'beforeSetErrors') ? options.beforeSetErrors : (errors) => errors,
      afterSetErrors: ObjectHelper.methodExists(options, 'afterSetErrors') ? options.afterSetErrors : () => null,
    };

    events.setErrors = (errors) => {
      let responseErrors = '' === formName ? errors : errors[formName];
      responseErrors = events.beforeSetErrors(responseErrors);

      if (formik && undefined !== responseErrors && 0 !== Object.keys(responseErrors).length) {
        formik.setErrors(responseErrors);
      }
      
      events.afterSetErrors(responseErrors);
    };

    try {
      const api = new Api();
      let response = null;

      if (this._auth) api.auth();

      if ('post' === method) {
        response = await api.post(endpoint, requestData);
      } else if ('put' === method) {
        response = await api.put(endpoint, requestData);
      } else {
        return false;
      }

      const {data = true} = response.data;

      if (formik) {
        formik.setSubmitting(false);
      }

      return data;
    } catch (error) {
      events.setErrors(error.response.data.data);
      return ApiError(error);
    }
  }

  async post(endpoint, data, options = {}) {
    return this._sendForm('post', endpoint, data, options);
  }

  async put(endpoint, data, options = {}) {
    return this._sendForm('put', endpoint, data, options);
  }

  async delete(endpoint) {
    const api = new Api();
    if (this._auth) api.auth();

    try {
      const response = await api.delete(endpoint);
      const {status, message} = response.data;

      if (!status) {
        ApiError({
          title: message
        });
        return false;
      }

      return true;
    } catch (error) {
      return ApiError(error);
    }
  }
}
